import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/mobile-menu/categories/134-marcas.svg")